'use strict';

var _ = require('lodash');
var ScheduleChangeFactory = function ScheduleChangeFactory(ScheduleChangeConstants, featureToggleService) {
  /**
   *
   * @param {string} entityType
   * @param {Array} entities
   * @constructor
   */
  function ScheduleChange(entityType, entities) {
    /**
     * @type {string}
     */
    this.entityType = entityType;

    /**
     * Array of all markets or legs managed by wizard
     * @type {(Array.ManagedMarket|Array.ManagedLeg)}
     */
    this.managedEntities = entities;

    /**
     * Array of only significant markets and legs
     * @type {(Array.ManagedMarket|Array.ManagedLeg)}
     */
    this.significantManagedEntities = [];
    this.orderedSignificantManagedEntities = {};
    this.managedEntities = orderManagedEntities(this.managedEntities);
    if (this.isMarkets()) {
      this.updateSignificantEntities();
    } else if (this.isLegs()) {
      this.significantManagedEntities = entities;
    }
  }
  ScheduleChange.prototype.isMarkets = function () {
    return this.entityType === ScheduleChangeConstants.ENTITIES.MARKETS;
  };
  ScheduleChange.prototype.isLegs = function () {
    return this.entityType === ScheduleChangeConstants.ENTITIES.LEGS;
  };
  function getGroupedEntities(entities) {
    var orderedEntities = {};
    _.forEach(entities, function (entity) {
      var reverseMarket = entity.destination + '-' + entity.origin;
      if (orderedEntities[reverseMarket]) {
        orderedEntities[reverseMarket].push(entity);
      } else {
        orderedEntities[entity.origin + '-' + entity.destination] = [entity];
      }
    });
    return orderedEntities;
  }
  function getSequenceOrderedEntities(groupEntities) {
    var sequenceOrderedEntities = [];
    _.forEach(groupEntities, function (entities) {
      sequenceOrderedEntities = sequenceOrderedEntities.concat(entities);
    });
    return sequenceOrderedEntities;
  }
  function orderManagedEntities(managedEntities) {
    var orderedManagedEntities = getGroupedEntities(managedEntities);
    return getSequenceOrderedEntities(orderedManagedEntities);
  }
  ScheduleChange.prototype.updateSignificantEntities = function () {
    if (!featureToggleService.isDisabled('SML')) {
      this.significantManagedEntities = _.chain(this.managedEntities).filter(['isSignificant', 'true']) //check
      .value();
    } else {
      //Significant markets are not available as a feature
      this.significantManagedEntities = this.managedEntities;
    }
    this.orderedSignificantManagedEntities = getGroupedEntities(this.significantManagedEntities);
  };
  ScheduleChange.prototype.getUniqSignificantPos = function (significantPos) {
    return _.uniqBy(significantPos, function (entity) {
      return entity.city + entity.country + entity.iataFrom + entity.iataTo + entity.spos;
    });
  };
  ScheduleChange.prototype.getStepResponsibleSignificantEntities = function () {
    if (this.isMarkets()) {
      var stepResponsibleEntities = [];
      _.forEach(this.significantManagedEntities, function (entity, i) {
        stepResponsibleEntities.push({
          isNew: entity.isNew,
          market: entity.market,
          assignee: entity.owner,
          marketIndex: i
        });
        /*
        var unique = _.uniqBy(entity.significantPos, function (pos) {
             return pos.city +
                pos.country +
                pos.iataFrom +
                pos.iataTo +
                pos.spos;
        });
        _.forEach(unique, function (pos, j) {
            stepResponsibleEntities.push({
                isNew: entity.isNew,
                market: entity.market,
                spos: pos.spos,
                assignee: pos.assignee,
                marketIndex: i,
                posIndex: j
            });
        });
         */
      });
      return stepResponsibleEntities;
    }
    return this.significantManagedEntities;
  };
  return ScheduleChange;
};
ScheduleChangeFactory.$inject = ['ScheduleChangeConstants', 'FeatureToggleService'];
module.exports = ScheduleChangeFactory;